




































import Vue from 'vue';
import { dateFormat, dateTransactionFormat } from '@/constants';
import { CloseFullscreenWrapper, FormValidation } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ReviewDepositForm } from '@/components/account-tools/make-deposit-components';
import { ExtendMixins, LoadingService } from '@/services';
import { ScheduledTransactionResponseModel } from '@/@types/member';
import store from '@/store';

interface Data {
  changeMade: boolean;
  isLoading: boolean;
  confirmBeforeClose: boolean;
  successMessage: string;
  errorMessage: string;
  accountId: string;
  showWrapper: boolean;
  dateFormat: string;
  dateTransactionFormat: string;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
).extend({
  name: 'UpdateScheduledDeposit',
  beforeRouteEnter(to, from, next) {
    LoadingService.watchPromises(store.dispatch('getGroupMigrationDates', store.getters.user.groupKey));
  },
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      changeMade: false,
      isLoading: false,
      confirmBeforeClose: true,
      successMessage: this.params.successMessage,
      errorMessage: this.params.errorMessage,
      accountId: this.params.accountId,
      showWrapper: true,
      dateFormat,
      dateTransactionFormat,
    };
  },
  computed: {
    selectedTransaction(): ScheduledTransactionResponseModel {
      return this.$store.getters.singleScheduledTransaction;
    },
  },
  methods: {
    updateConfirmBeforeClose(val): void {
      this.confirmBeforeClose = val;
    },
    doneLoading(): void {
      this.showWrapper = false;
    },
    toggleLoading(val): void {
      this.isLoading = val;
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
    ReviewDepositForm,
  },
});
